import { Calendar } from "mobily-ui-library/lib/components/composite/calendar/Calendar";
import React from "react";
import "./CustomCalendar.scss";
import { Form } from "antd";
import { useTranslation } from 'react-i18next';

const CustomCalendar: React.FC<any> = ({handleChange, error, rtl, value, hint, maxLength, headingleft, className, name, rules, placeholder, ...props}) => {
    const { t } = useTranslation();
    return (
        <div className={`${error?.length > 0 ? "error" : "normal"} mb-3`}>
            
            <div className='inputField__error d-flex flex-column'>
                <div className={`d-flex align-items-center ${rtl ? 'flex-right rtl' : ''}`}>
                    <Form.Item
                        name={name}
                        rules={rules}
                        hasFeedback
                    >
                    <Calendar calanderTypes={[{type:'arabic',label: t('From_Hijri')},{type:'gregorian',label:t('From_Gregorian')}]} placeholder={t("SelectDate")} {...props} lang={'en'}/>
                    </Form.Item>
                    {hint ? <div className='hint-tooltip' data-tooltip={hint} /> : <div className="gap-18"></div>}
                </div>
            </div>
        </div>
    )
}

export default CustomCalendar;
